const ddados = {
  Titulo: "Consultar Protocolo",
  Campos: {
    Analise: {
      Tipo: "number",
      Label: "Análise",
      Tooltip: "Análise",
    },
    AnaliseOrgao: {
      Tipo: "number",
      Label: "Análise Órgão",
      Tooltip: "Análise Órgão",
    },
    Orgao:{
      Tipo: "text",
      Label: "Órgão",
      Tooltip: "Órgão",
    },
    Servico:{
      Tipo: "text",
      Label: "Serviço",
      Tooltip: "Serviço",
    },
    DataInicio: {
      Tipo: "date",
      Tooltip: "Data Início",
      Label: "Data Início",
    },
    StatusAnalise:{
      Tipo: "text",
      Label: "Status Análise",
      Tooltip: "Status Análise",
    },
    DataFinal: {
      Tipo: "date",
      Tooltip: "Data Final",
      Label: "Data Final",
    },
    Usuario: {
      Tipo: "text",
      Tooltip: "Usuário",
      Label: "Usuário",
    },


    Exigencia:{
      Tipo: "text",
      Label: "Exigência",
      Tooltip: "Exigência",
    },
    Motivo:{
      Tipo: "text",
      Label: "Motivo",
      Tooltip: "Motivo",
    },
    DataRetorno: {
      Tipo: "date",
      Tooltip: "Data Retorno",
      Label: "Data Retorno",
    },
    Retorno:{
      Tipo: "text",
      Label: "Retorno",
      Tooltip: "Retorno",
    },

    NumeroDocumento:{
      Tipo: "number",
      Label: "Número Documento",
      Tooltip: "Número Documento",
    },
    TipoDocumento:{
      Tipo: "text",
      Label: "Tipo Documento",
      Tooltip: "Tipo Documento",
    },
    DataValidade: {
      Tipo: "date",
      Tooltip: "Data Validade",
      Label: "Data Validade",
    },
    UrlDocumento:{
      Tipo: "text",
      Label: "Url Documento",
      Tooltip: "Url Documento",
    },

    MotivoIndeferimento:{
      Tipo: "text",
      Label: "Motivo Indeferimento",
      Tooltip: "Motivo Indeferimento",
    },
    MotivoCancelar:{
      Tipo: "text",
      Label: "Motivo Cancelar",
      Tooltip: "Motivo Cancelar",
    },

    Observacao:{
      Tipo: "text",
      Label: "Observação",
      Tooltip: "Observação",
    },
    CPFSolicitante:{
      Tipo: "text",
      Label: "CPF Solicitante",
      Tooltip: "CPF Solicitante",
    },
    Solicitante:{
      Tipo: "text",
      Label: "Solicitante",
      Tooltip: "Solicitante",
    },
    CpfCnpj: {
      Tipo: "mask",
      Mascara: "CPFCNPJ",
      Label: "CPF / CNPJ",
      Tooltip: "CPF / CNPJ",
      Obrigatorio: true,
    },

  }
};

export { ddados };
